import React from 'react'

import styles from './FormInput.module.scss'

export default ({ children,error,  label, ...props }) => (
  <>
    <fieldset
      {...props}
      className={[styles.fieldset, label ? styles.fieldsetWithLabel : '', error ? styles.error:''].join(
        ' '
      )}
    >
      {label && <label>{label}</label>}
      {children}
    </fieldset>
  </>
)
